module.exports = __webpack_public_path__ + "img/hot_have.55025c5b.png";